<template>
  <div class="main_container back1" >
    <div class="img_right desktop"><img src="./assets/img/img.jpg" alt="תמונת אוירה כדורים "/></div>
    <div class="main_section">
      <div class="main_logo">
        <picture>
          <source media="(max-width:768px)" srcset="./assets/img/logo_mob.jpg">
          <img src="./assets/img/logo.jpg" alt="מכבי שירותי בריאות">
        </picture>
      </div>
      <div class="main_title margB1">
        <h1 class="title textT1 boldType color2">
          שווה לדעת, שווה לחסוך
        </h1>
        <div class="img_mob mobile"><img src="./assets/img/img_mob.jpg" alt="תמונת אוירה כדורים "/></div>
      </div>
      <p class="textT2 margB1">
        כשמדובר בבריאות שלכם ושל משפחתכם תמיד כדאי להיות מעודכנים בכל מה שחשוב.
        הזינו את פרטיכם וקבלו מאתנו מידע בנושא בריאות ובנוסף תהיו הראשונים לדעת על כל המבצעים והנחות שלנו.
      </p>
      <form-app/>
    </div>





<!--    <div class="section_credit textT3"><a target="_blank" href="https://www.datapro.co.il/"><span>Data Pro</span> | proximity</a></div>-->
  </div>
</template>

<script>

import formApp from './components/formApp.vue';



export default {
  name: 'App',
  components: {
    formApp
  },
}
</script>

<style lang="scss">
.main_container{
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding:65px 130px 45px;
  max-width:1920px;
  margin:0 auto;
  //min-height: 99vh;
  @include breakpoint('point1') {padding:vw-d(65) vw-d(130) vw-d(45);}
  @include breakpoint('mobile') {padding:vw-m(26) vw-m(24);}
}
.img_right {
  width: 23.3%;
  margin: 0 1.2% 0 8.19%;
}
.main_section {
  width: 67.31%;
  @include breakpoint('mobile') {width: 100%;}
}
.main_logo {
  width: 28%;
  margin: 0 auto 80px;
  @include breakpoint('point1') {margin-bottom: vw-d(80);}
  @include breakpoint('mobile') {margin-bottom: vw-m(6); width:vw-m(141);}
}
.main_title{
  @include breakpoint('mobile') {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .img_mob{
      width:29%;

    }
    .title{
      width:70%;
    }
  }
}
.section_credit {
  font-family: Arial, sans-serif;
  text-align: center;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  @include breakpoint('point1'){
    bottom: vw-d(10);
  }
  @include breakpoint('mobile') {
    bottom: vw-m(10);
  }
  span{font-weight: 600;}
}
</style>
